<template>
  <div class="input-btn">
    <input
      type="text"
      :placeholder="placeholder"
      v-model="value"
    >
    <btn
      :disabled="!value"
      color="outline"
      size="sm"
      @click="$emit('submit', value)"
    >
      <slot />
    </btn>
  </div>
</template>

<script>
import Btn from './Btn'
export default {
  components: {
    Btn
  },

  props: {
    placeholder: { type: String, required: false }
  },

  name: 'InputBtn',

  data () {
    return {
      value: null
    }
  }
}
</script>
